import feathersClient from "../../feathers-client";

const defaultSwapRequestPagination = {
	total: 100,
	$skip: 0,
	$limit: 4,
};
const defaultManagerSwapRequestPagination = {
	total: 100,
	$skip: 0,
	$limit: 4,
};
const defaultSwapRequestPaginationFilter = {
	$skip: defaultSwapRequestPagination.$skip,
	$limit: defaultSwapRequestPagination.$limit,
};
const defaultManagerSwapRequestPaginationFilter = {
	$skip: defaultManagerSwapRequestPagination.$skip,
	$limit: defaultManagerSwapRequestPagination.$limit,
};

export default {
	state: {
		SwapRequestPagination: defaultSwapRequestPagination,
		swapRequest: [],
		SwapRequestPaginationFilter: defaultSwapRequestPaginationFilter,
		SwapRequestFilter: defaultSwapRequestPaginationFilter,

		ManagerSwapRequestPagination: defaultManagerSwapRequestPagination,
		managerSwapRequest: [],
		ManagerSwapRequestPaginationFilter:
			defaultManagerSwapRequestPaginationFilter,
		ManagerSwapRequestFilter: defaultManagerSwapRequestPaginationFilter,
	},
	getters: {
		setSwapRequestPage: (state) => {
			const { $limit, $skip } = state.SwapRequestPagination;
			return $skip / $limit + 1;
		},
		setManagerSwapRequestPage: (state) => {
			const { $limit, $skip } = state.ManagerSwapRequestPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_SWAP_REQUEST: (state, data) => {
			state.swapRequest = data;
		},
		SET_SWAP_REQUEST_PAGINATION: (state, data) => {
			state.SwapRequestPagination = {
				...state.SwapRequestPagination,
				...data,
			};
		},
		SET_SWAP_REQUEST_PAGINATION_FILTER: (state, data) => {
			state.SwapRequestPaginationFilter = {
				...state.SwapRequestPaginationFilter,
				...data,
			};
		},
		SET_SWAP_REQUEST_LIST_FILTER: (state, data) => {
			state.SwapRequestFilter = { ...state.SwapRequestFilter, ...data };
		},

		SET_MANAGER_SWAP_REQUEST: (state, data) => {
			state.managerSwapRequest = data;
		},
		SET_MANAGER_SWAP_REQUEST_PAGINATION: (state, data) => {
			state.ManagerSwapRequestPagination = {
				...state.ManagerSwapRequestPagination,
				...data,
			};
		},
		SET_MANAGER_SWAP_REQUEST_PAGINATION_FILTER: (state, data) => {
			state.ManagerSwapRequestPaginationFilter = {
				...state.ManagerSwapRequestPaginationFilter,
				...data,
			};
		},
		SET_MANAGER_SWAP_REQUEST_LIST_FILTER: (state, data) => {
			state.ManagerSwapRequestFilter = {
				...state.ManagerSwapRequestFilter,
				...data,
			};
		},
	},
	actions: {
		setSwapRequestListPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.SwapRequestPagination.$limit;
			commit("SET_SWAP_REQUEST_PAGINATION", { $skip });
			commit("SET_SWAP_REQUEST_LIST_FILTER", { $skip });
		},
		setManagerSwapRequestListPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.SwapRequestPagination.$limit;
			commit("SET_MANAGER_SWAP_REQUEST_PAGINATION", { $skip });
			commit("SET_MANAGER_SWAP_REQUEST_LIST_FILTER", { $skip });
		},

		getStaffSwapRequest: async ({ rootGetters, commit, state }, filter) => {
			const results = await feathersClient
				.service("/api/v3/swap-offers")
				.find({
					query: {
						$role: rootGetters.currentUserRole,
						...filter,
					},
				});
			commit("SET_SWAP_REQUEST", results.data);
			commit("SET_SWAP_REQUEST_PAGINATION", { total: results.total });
			return results.data;
		},
		getManagerSwapRequest: async (
			{ rootGetters, commit, state },
			filter
		) => {
			const results = await feathersClient
				.service("/api/v3/manager-swap-requests")
				.find({
					query: {
						$role: rootGetters.currentUserRole,
						...filter,
					},
				});
			commit("SET_MANAGER_SWAP_REQUEST", results.data);
			commit("SET_MANAGER_SWAP_REQUEST_PAGINATION", {
				total: results.total,
			});
			return results.data;
		},
		updateManagerSwapRequest: async (
			{ rootGetters, commit, state },
			filter
		) => {
			if (!filter.id) {
				throw new Error("updateRequest: missing request id");
			}

			const id = filter.id;

			// Remove id before putting filter params into query
			const { id: _, ...queryFilter } = filter;
			const result = await feathersClient
				.service("/api/v3/manager-swap-requests")
				.patch(
					id, // <-- REQUIRED (this is the URL :id)
					{ reconciliation: "PARTIALLY_RECONCILED" }, // <-- REQUIRED data object (empty is OK)
					{
						query: {
							$role: rootGetters.currentUserRole,
						},
					}
				);

			commit("SET_MANAGER_SWAP_REQUEST", result.data);
			return result;
		},
		updateStaffSwapRequest: async (
			{ rootGetters, commit, state },
			filter
		) => {
			if (!filter.id) {
				throw new Error("updateRequest: missing request id");
			}

			const id = filter.id;
             let reconciliationValue;
			 if(filter.activeSmallTab === 'rosterToRoster') {
				reconciliationValue = 'RECONCILED';
			} else {
				reconciliationValue = 'PARTIALLY_RECONCILED';
			}
			// Remove id before putting filter params into query
			const { id: _, ...queryFilter } = filter;
			const result = await feathersClient
				.service("/api/v3/swap-offers")
				.patch(
					id, // <-- REQUIRED (this is the URL :id)
					{ reconciliation: reconciliationValue }, // <-- REQUIRED data object (empty is OK)
					{
						query: {
							$role: rootGetters.currentUserRole,
						},
					}
				);

			commit("SET_SWAP_REQUEST", result.data);
			return result;
		},
		updateManyManagerSwapRequest: async (
			{ rootGetters, commit },
			requestIdLists
		) => {
			let requestIdList = [requestIdLists];
			if (
				!Array.isArray(requestIdList) ||
				(requestIdList.length <= 1 &&
					requestIdList[0]?.requestIdList?.length == 0)
			) {
				throw new Error("Missing requestId list");
			}
			const result = await feathersClient
				.service("/api/v3/manager-swap-requests")
				.patch(
					null, //  REQUIRED for multi-patch
					{
						reconciliation: "PARTIALLY_RECONCILED",
					},
					{
						query: {
							_id: { $in: requestIdList }, //  filter goes here
							$role: rootGetters.currentUserRole,
							status: "AWAITING_APPROVAL",
							reconciliation: "PENDING",
							$multiReconciliation: true,
						},
					}
				);

			commit("SET_MANAGER_SWAP_REQUEST", result);
			return result;
		},
		updateManyStaffSwapRequest: async (
			{ rootGetters, commit },
			requestIdLists
		) => {
			let requestIdList = [requestIdLists.requestIdList];
			if (
				!Array.isArray(requestIdList) ||
				(requestIdList.length <= 1 &&
					requestIdList[0]?.requestIdList?.length == 0)
			) {
				throw new Error("Missing requestId list");
			}
			 let reconciliationValue;
			 if(requestIdLists.activeSmallTab === 'rosterToRoster') {
				reconciliationValue = 'RECONCILED';
			} else {
				reconciliationValue = 'PARTIALLY_RECONCILED';
			}
			const result = await feathersClient
				.service("/api/v3/swap-offers")
				.patch(
					null, //  REQUIRED for multi-patch
					{
						reconciliation: reconciliationValue,
					},
					{
						query: {
							_id: { $in: requestIdList }, //  filter goes here
							$role: rootGetters.currentUserRole,
							status: "AWAITING",
							reconciliation: "PENDING",
							$multiReconciliation: true,
						},
					}
				);

			commit("SET_SWAP_REQUEST", result);
			return result;
		},

		exportManagerSwapRequest: async ({ rootGetters }, filter) => {
			const results = await feathersClient
				.service("/api/v3/manager-swap-requests")
				.find({
					query: {
						$role: rootGetters.currentUserRole,
						trustId: rootGetters.currentTrustId,
						...filter,
					},
				});
			return results;
		},
		exportStaffSwapRequest: async ({ rootGetters }, filter) => {
			const results = await feathersClient
				.service("/api/v3/swap-offers")
				.find({
					query: {
						$role: rootGetters.currentUserRole,
						trustId: rootGetters.currentTrustId,
						...filter,
					},
				});
			return results;
		},
	},
};
